<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          {{ count }} Relations
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="isPromoteur"
          class="page-header-btn is-small is-primary"
          :to="{name: 'NewInvitation'}">
          <!--<span class="icon"><i class="fal fa-paper-plane"></i></span>-->
          <span>Inviter partenaire</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <!-- <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <r-label
              :is-required="false"
              :label="'Société'"></r-label>
            <div class="field">
              <div class="control">
                <input
                  id="company-name-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.company_name"
                  class="input"
                  type="text"
                  placeholder="Nom">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  id="company-email-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.company_email"
                  class="input"
                  type="text"
                  placeholder="Email">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  id="company-phone-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.company_phone"
                  class="input"
                  type="text"
                  placeholder="Téléphone">
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template> -->
      <div>
        <!-- <router-view
          @removeRelation="removeRelation"
          @removeInvitation="removeInvitation"
          @canceledInvitation="removeInvitation"
          @deleteRelation="deleteRelation"
          @updateRelationStatus="updateRelationStatus"
          @reload="reload"
          :loading="loading"
          :companies="companies"
          :relations="myRelations"></router-view> -->
        <router-view
          @removeRelation="removeRelation"
          @removeInvitation="removeInvitation"
          @canceledInvitation="removeInvitation"
          @deleteRelation="deleteRelationLink"
          @updateRelationStatus="updateRelationStatus"
          @updateRelationFilter="updateRelationFilter"
          @reload="reload"
          :loading="loading"
          :companies="companies"
          :relations="myRelations"
          :invitations="myInvitations"
          :list-elements="myListElements"
          :total-pages-child="totalPages"></router-view>
      </div>
      <pagination
        :loading="loading"
        :current-page="currentPage"
        :total-page="totalPages"
        @changePage="loadData($event)"></pagination>
    </page-content>
  </div>
</template>

<script>
import ErrorMixin from '@/mixins/ErrorMixin'
import { Quickview, Filter, FilterGetter, Sort, GenericList } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import { concat, sortBy } from 'lodash'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'Relations',
  mixins: [ErrorMixin, Quickview, Filter, FilterGetter, Sort, GenericList],
  data () {
    return {
      loadDocuments: this.loadItems,
      totalPages: null,
      loading: false,
      allRelations: null,
      companyStatus: [
        {
          value: 'accepted',
          label: 'Accepté'
        },
        {
          value: 'pending',
          label: 'En attente'
        },
        {
          value: 'rejected',
          label: 'Refusé'
        }
      ],
      filters: {
        company_name: null,
        company_email: null,
        company_phone: null,
        company_status: [],
        admin_name: null,
        admin_email: null,
        admin_phone: null,
        searchable_name: null
      },
      invitationFilters: {
        company_name: null,
        company_email: null,
        company_phone: null,
        company_status: [],
        admin_name: null,
        admin_email: null,
        admin_phone: null
      },
      invitation: {},
      relations: [],
      relationsList: null,
      totalRelations: null,
      invitations: [],
      companies: [],
      service: 'RELATIONS_LINK',
      // service: 'ACCOUNT',
      openedCol: false,
      listElements: null,
      testRelation: null,
      testInvitation: null,
      filtersStatus: []
    }
  },
  computed: {
    ...mapGetters(['isPromoteur']),
    ...mapState(['currentUser', 'quickview']),
    canAdd () {
      return this.currentUser.account.account_type === 'promoteur' && this.currentUser.profil === 'admin'
    },
    currentTab () {
      return this.$route.name
    },
    tabLinks () {
      let tab = [
        { link: 'RelationsList', label: `VOS RELATIONS` }
      ]
      return tab
    },
    myRelations () {
      if (this.relations && this.relations.length) {
        return this.relations.filter(x => {
          return this.items.some(acc => acc.pk === x.account_two.pk || acc.pk === x.account_one.pk)
        })
      } else {
        return []
      }
    },
    myInvitations () {
      if (this.isPromoteur) {
        let relationStatus = ['refused', 'pending']
        let relations = this.relations.filter(x => {
          return relationStatus.includes(x.status)
        })
        return concat(relations, this.invitations)
      } else {
        return this.relations.filter(x => {
          return x.status === 'pending'
        })
      }
    },
    myListElements () {
      return this.listElements
    }
  },
  watch: {
    'currentTab' (value, oldValue) {
      this.initWidget()
    },
    quickview ({ mode, params, results }) {
      if (!mode && !params && !results) {
        this.initWidget()
        this.loadDocuments()
      }
    },
    filtersStatus (v) {
      console.log('v ====>', v)
    }
  },
  created () {
    this.initWidget()
    bus.$on(EVENTS.RELATION_REFUSED, (data) => {
      this.reload()
    })
    bus.$on(EVENTS.RELATION_ACCEPTED, (data) => {
      this.reload()
    })
    bus.$on(EVENTS.RELATION_CREATED, (data) => {
      this.getRelation(data.resource_pk)
    })
    // this.initPagination()
    this.getRelationLink()
    this.updateRelationFilter()
  },
  updated () {
    this.initPagination()
  },
  destroyed () {
    bus.$off([EVENTS.RELATION_REFUSED, EVENTS.RELATION_ACCEPTED, EVENTS.RELATION_CREATED])
  },
  methods: {
    async getRelation (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT_RELATION, id)
        this.$store.commit('addRelations', data)
        this.reload()
      } catch (err) {
        console.log(err)
      }
    },
    reload () {
      this.getRelations()
      this.getInvitations()
      this.getRelationLink()
      this.updateRelationFilter()
    },
    async removeRelation (relationPk) {
      try {
        await this.$api.delete(this.$resources.ACCOUNT_RELATION, relationPk)
      } catch (e) {
        this.$toasted.global.danger('Impossible de supprimer cette relation')
      }
      this.getRelations()
    },
    async updateRelationStatus (relationPk, status) {
      try {
        await this.$api.patch(this.$resources.ACCOUNT_RELATION, relationPk, {
          status
        })
        if (status === 'refused') {
          this.$toasted.global.success('Relation refusée')
        }
        if (status === 'accepted') {
          await this.getAccounts()
          this.$toasted.global.success('Relation acceptée')
          this.$router.push({ name: 'RelationsList' })
        }
        this.reload()
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Impossible de modifier cette relation')
      }
    },
    async getAccounts () {
      const params = {
        status: 'accepted'
      }
      const request = await this.$api.get(this.$resources.ACCOUNT_RELATION, params)
      let accounts = []
      if (this.currentUser && this.currentUser.account && this.currentUser.account.account_type === 'promoteur') {
        accounts = request.data.items.map(x => x.account_two)
      } else if (this.currentUser && this.currentUser.account && this.currentUser.account.account_type === 'commercial') {
        accounts = request.data.items.map(x => x.account_one)
      }
      const myAccount = {
        name: this.currentUser.account.name,
        pk: this.currentUser.account.pk
      }
      accounts.push(myAccount)
      accounts = sortBy(accounts, x => x.name)
      this.$store.commit('setAccounts', { accounts })
    },
    async removeInvitation (invitationPk) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.INVITATION, invitationPk)
          this.$toasted.global.success('Invitation supprimée')
        } catch (e) {
          this.$toasted.global.danger('Impossible de supprimer cette invitation')
        }
        this.reload()
      }
    },
    async deleteRelation (relationPk) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCOUNT_RELATION, relationPk)
          this.$toasted.global.success('Invitation supprimée')
        } catch (e) {
          this.$toasted.global.danger('Impossible de supprimer cette invitation')
        }
        this.reload()
      }
    },
    async checkUser () {
      let request = await this.$api.axios.get('user-lookup', {
        params: {
          email: this.invitation.email
        }
      })
      const check = request.data
      if (check.valid && check.account !== null && check.user !== null) {
        this.newRelation(check.account)
      } else if (check.valid) {
        this.sendInvitation()
      } else if (check.account_type === 'promoteur' && !check.valid) {
        this.$toasted.global.danger('Impossible d\'inviter un promoteur')
      } else {
        this.$toasted.global.danger('Cet email n\'est pas valide')
      }
    },
    async newRelation (account) {
      let preAccessList = this.invitation.remByProg.map(x => {
        return {
          program: x.program,
          remuneration: x.remuneration
        }
      })
      const payload = {
        account_two: account,
        pre_access_list: preAccessList
      }
      try {
        await this.$api.post(this.$resources.ACCOUNT_RELATION, payload)
        this.$toasted.global.success('Demande de mise en relation envoyée')
      } catch (e) {
        this.$toasted.global.danger('Impossible de demander une mise en relation')
      }
      this.getRelations()
    },
    async sendInvitation () {
      let preAccessList = this.invitation.remByProg.map(x => {
        return {
          program: x.program,
          remuneration: x.remuneration
        }
      })
      let payload = {
        first_name: this.invitation.firstName,
        last_name: this.invitation.lastName,
        email: this.invitation.email,
        pre_access_list: preAccessList
      }
      try {
        await this.$api.post(this.$resources.INVITATION, payload)
        this.$toasted.global.success('Invitation envoyée')
        this.getInvitations()
        this.tab = 'invitations'
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    },
    loadData ($event) {
      this.getRelationLink($event)
    },
    initPagination () {
      if (this.relationsPages && this.currentRelationPage) {
        this.totalPages = this.relationsPages
        this.currentPage = this.currentRelationPage
      }
    },
    async getCompanies (page = 1) {
      this.loading = true
      let query = {
        per_page: 100,
        page: 1
      }
      if (page !== 1) query.page = page
      let request = await this.$api.get(this.$resources.ACCOUNT, query)
      // this.initPagination(request.data)
      this.companies = request.data.items
      this.loading = false
    },
    async getInvitations (query) {
      let filter
      if (query) {
        filter = {
          per_page: 50,
          first_name: query
        }
      }
      this.loading = true
      let { data } = await this.$api.get(this.$resources.INVITATION, filter)
      // this.invitations = request.data.items
      this.invitations = data.items
      this.testInvitation = data
      this.loading = false
    },
    async getRelations (page = null) {
      this.loading += 1
      this.loading = true
      let query = {
        per_page: 50,
        page: 1
      }
      if (page !== 1) query.page = page
      let { data } = await this.$api.get(this.$resources.ACCOUNT_RELATION, query)
      this.relations = data.items
      this.testRelation = data
      // this.totalPages = data.pages
      let relations = this.relations
      this.$store.commit('setRelations', { relations })
      this.loading = false
    },
    async initWidget () {
      this.getCompanies()
      if (!this.relations.length) {
        this.getRelations()
      }
      if (!this.invitations.length) {
        this.getInvitations()
      }
    },
    async getRelationLink (page = 1) {
      if (this.$route.query.page) {
        page = this.$route.query.page
      }
      let params = {
        page,
        per_page: 50
      }
      if (this.filtersStatus) {
        params.status = this.filtersStatus
      }
      this.loading = true
      try {
        const { data } = await this.$api.get(this.$resources.RELATIONS_LINK, params)
        this.totalRelations = data.count
        this.relationsList = data.items
        this.relationsListCount = data.count
        this.relationsPages = data.pages
        this.currentRelationPage = data.page
        this.listElements = data
        const list = data.items
        this.$store.commit('setRelationsLink', { list })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async deleteRelationLink (relationPk) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.RELATIONS_LINK, relationPk)
          this.$toasted.global.success('Invitation supprimée')
        } catch (e) {
          this.$toasted.global.danger('Impossible de supprimer cette invitation')
        }
        this.reload()
      }
    },
    updateRelationFilter (status) {
      let filter = []
      if (status) {
        for (let stat of status) {
          filter.push(stat)
        }
        this.filtersStatus = filter
        this.reload()
      }
    }
  }
}
</script>
